/**
 * GapImage MDXEditor Plugin
 *
 * Renders an S3-backed image block.
 *
 * MARKDOWN SYNTAX (leafDirective - block-level):
 * ::GapImage{name="photo.jpg" rawFileName="photo-abc123.jpg"}
 */
import { DirectiveDescriptor } from "@mdxeditor/editor"
import GapImageComponent from "./GapImageComponent"

export const DIRECTIVE_NAME = 'GapImage'

export const GapImageDirectiveDescriptor: DirectiveDescriptor = {
   name: DIRECTIVE_NAME,
   type: 'leafDirective',
   testNode(node) {
      return node.name === DIRECTIVE_NAME
   },
   attributes: ['name', 'rawFileName', 'width', 'height'],
   hasChildren: false,
   Editor: GapImageComponent,
}
